import queryParams from '../utils/queryParams'
// const userAgent = window.navigator.userAgent
// const persistentCache = window.persistentCache
// export default /(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/i.test(userAgent) || (/Android/i.test(userAgent) && persistentCache && persistentCache.disabled)
export default !!(queryParams.terminal || queryParams.urlClientIDParameter)
